import React from "react";
import styles from "./Header.module.css"; // import as styles

const Header = () => {
  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <ul>
          <li><a href="#about">About App</a></li>
          <li><a href="#jcm">About JCM</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
